import { render, staticRenderFns } from "./ShowPercepcionMaternidadCertificado.vue?vue&type=template&id=57dc0802&scoped=true&"
import script from "./ShowPercepcionMaternidadCertificado.vue?vue&type=script&lang=js&"
export * from "./ShowPercepcionMaternidadCertificado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dc0802",
  null
  
)

export default component.exports